<template>
  <div>
    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">{{ $t('workFileTracking.tracking.requestSummary') }}</legend>
      <InfoTable :level="level">
        <InfoTableItem>
          <template v-if="workRequest.type === 'electricity'" v-slot:icon>
            <i class="lib__infotable__icon fas">
              <img class="lib__infotable__icon" style="width: 14px; height: 16px;" alt="Electicity"
                :src="require('@ores/css-library/assets/img/icons/electricity.svg')" />
            </i>
          </template>
          <template v-else-if="workRequest.type === 'gas'" v-slot:icon>
            <i class="lib__infotable__icon fas">
              <img class="lib__infotable__icon" style="width: 14px; height: 16px;" alt="Gas"
                :src="require('@ores/css-library/assets/img/icons/gas.svg')" />
            </i>
          </template>
          <template v-else-if="workRequest.type === 'phone'" v-slot:icon><i
              class="lib__infotable__icon fas fa-phone"></i></template>
          <template v-else-if="workRequest.type === 'television'" v-slot:icon><i
              class="lib__infotable__icon fas fa-tv"></i></template>
          <template v-else-if="workRequest.type === 'water'" v-slot:icon><i
              class="lib__infotable__icon fas fa-tint"></i></template>
          <template v-else-if="workRequest.type === 'unknown'" v-slot:icon><i
              class="lib__infotable__icon fas fa-question"></i></template>

          <template v-slot:label>{{ $t('workFileTracking.tracking.workType') }} : </template>
          <template v-slot:value>{{ workType }}</template>
        </InfoTableItem>
        <template v-if="notAuthorizedWorkRequest">
          <InfoTableItem>
            <template v-slot:icon><i class="lib__infotable__icon fas fa-tasks"></i></template>
            <template v-slot:label>{{ $t('workFileTracking.tracking.status') }} : </template>
            <template v-slot:value>{{ $t('workFileTracking.tracking.noTrackingMessage') }}</template>
          </InfoTableItem>
        </template>
        <template v-else-if="workRequest.type !== 'electricity' && workRequest.type !== 'gas'">
          <InfoTableItem>
            <template v-slot:icon><i class="lib__infotable__icon fas fa-tasks"></i></template>
            <template v-slot:label>{{ $t('workFileTracking.tracking.status') }} : </template>
            <template v-if="workRequest.type === 'phone'" v-slot:value>{{
              $t('workFileTracking.tracking.cmhProximusStatusMessage') }}</template>
            <template v-else-if="workRequest.type === 'television'" v-slot:value>{{
              $t('workFileTracking.tracking.cmhVooStatusMessage') }}</template>
            <template v-else-if="workRequest.type === 'water'" v-slot:value>{{
              $t('workFileTracking.tracking.cmhSwdeStatusMessage') }}</template>
          </InfoTableItem>
        </template>
        <template v-else>
          <InfoTableItem>
            <template v-slot:icon><i class="lib__infotable__icon fas fa-tasks"></i></template>
            <template v-slot:label>{{ $t('workFileTracking.tracking.status') }} : </template>
            <template v-slot:value>{{ status }}</template>
          </InfoTableItem>
          <InfoTableItem v-if="executionDate">
            <template v-slot:icon><i class="lib__infotable__icon fas fa-calendar"></i></template>
            <template v-slot:label>{{ $t('workFileTracking.tracking.executionDate') }} : </template>
            <template v-slot:value>{{ executionDate }}</template>
          </InfoTableItem>
          <InfoTableItem v-if="executionDate && workFile.canModifyAppointment" button>
            <div class="lib__tooltips lib__tooltips--top-left">
              <button style="margin-right:20px;" :disabled="!canModifyCancelAppointment" @click="modifyDate"
                class="lib__btn lib__btn--rounded lib__btn--primary" type="button">
                {{ $t('workFileTracking.tracking.modifyDate') }}
              </button>
              <span>
              </span>
              <span class="lib__tooltips__data" v-if="outOfClick">{{ $t('workFileTracking.tracking.outOfClickModify')
              }}</span>
              <span class="lib__tooltips__data" v-else-if="!canModifyCancelAppointmentBusinessCondition">{{
                $t('workFileTracking.tracking.forModifyAppointment') }}</span>
            </div>
            <div class="lib__tooltips lib__tooltips--top-left" v-if="workFile.canCancelWorkFile">
              <button :disabled="!canModifyCancelAppointment" @click="cancelWork"
                class="lib__btn lib__btn--rounded lib__btn--primary" type="button">
                {{ $t('workFileTracking.tracking.cancelWork') }}
              </button>
              <span>
              </span>
              <span class="lib__tooltips__data" v-if="outOfClick">{{ $t('workFileTracking.tracking.outOfClickCancel')
              }}</span>
              <span class="lib__tooltips__data" v-else-if="!canModifyCancelAppointmentBusinessCondition">{{
                $t('workFileTracking.tracking.forCancelAppointment') }}</span>
            </div>
          </InfoTableItem>
          <InfoTableItem v-if="showPrice">
            <template v-slot:icon><i class="lib__infotable__icon fas fa-euro-sign"></i></template>
            <template v-slot:label>{{ $t('workFileTracking.tracking.price') }} : </template>
            <template v-slot:value>
              <p>{{ price }}</p>
            </template>
          </InfoTableItem>
          <InfoTableItem
            v-if="isSmartMeterWorkFileWithOwnerTenantUsufructuary && showPrice && workRequest.prime && workRequest.prime > 0">
            <template v-slot:label>{{ $t('workFileTracking.tracking.smartMeter.governmentTitle') }} : </template>
            <template v-slot:value>
              <p>- {{ workRequest.prime }} {{ $t('workFileTracking.tracking.euroVatInvoiceAfterWork') }}</p>
              <div class="lib__field__note" style="font-size:1.0rem">
                <i>{{ $t('workFileTracking.tracking.smartMeter.governmentMessage', { prime: workRequest.prime }) }}</i>
              </div>
            </template>
          </InfoTableItem>
          <!--          Ajouter la condition du champ Intervention Ores quand il sera dispo côté OCS-->
          <InfoTableItem v-if="isSmartMeterWorkFileWithOwnerTenantUsufructuary && showPrice && false">
            <template v-slot:label>{{ $t('workFileTracking.tracking.smartMeter.oresInterventionTitle') }} : </template>
            <template v-slot:value>
              <p>- {{ workRequest.prime }} {{ $t('workFileTracking.tracking.euroVatInvoiceAfterWork') }}</p>
              <div class="lib__field__note" style="font-size:1.0rem">
                <i>{{ $t('workFileTracking.tracking.smartMeter.oresInterventionMessage', { prime: workRequest.prime })
                }}</i>
              </div>
            </template>
          </InfoTableItem>
          <InfoTableItem v-if="isSmartMeterWorkFileWithOwnerTenantUsufructuary && showPrice">
            <template v-slot:label>{{ $t('workFileTracking.tracking.totalPrice') }}</template>
            <template v-slot:value>
              <p>{{ workRequest.calculatedPriceWithoutPrime }} {{
                $t('workFileTracking.tracking.euroVatInvoiceAfterWork') }}</p>
            </template>
          </InfoTableItem>
        </template>
      </InfoTable>

      <Feedback icon level="alert"
        v-if="(workRequest.type === 'electricity' || workRequest.type === 'gas') && showPrice">
        <p>{{ $t('workFileTracking.tracking.priceWarning') }}</p>
      </Feedback>

    </fieldset>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  PhaseSystemStatus,
  WorkRequest,
  WorkFile,
  WorkOfferType,
  WorkRequestType,
  PowerLevel,
  WorkRequestTopic,
  ClientType,
  WorkAppointment
} from '@/models'
import { dateService, timeService } from '@ores/vue-library'

@Component({
  name: 'work-request-summary'
})
export default class WorkRequestSummary extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly workRequest!: WorkRequest
  @Prop({ type: Object, required: true }) public readonly workFile!: WorkFile
  @Prop({ type: Boolean, required: false, default: false }) public readonly notAuthorizedWorkRequest!: boolean
  //#endregion

  //#region [Computed]
  public get showPrice(): boolean {
    return (
      this.workRequest.offerType !== WorkOfferType.WrittenOffer ||
      this.workRequest.phases.some(
        (p) => p.phaseNumber === 3 && (p.status === PhaseSystemStatus.Ongoing || p.status === PhaseSystemStatus.Closed)
      )
    )
  }

  public get level(): string {
    switch (this.workRequest.type) {
      case WorkRequestType.Electricity:
        return 'primary'
      case WorkRequestType.Gas:
        return 'secondary'
      case WorkRequestType.Water:
        return 'success'
      case WorkRequestType.Phone:
        return 'alert'
      case WorkRequestType.Television:
        return 'danger'
      default:
        return ''
    }
  }

  public get workRequestCancelled(): boolean {
    if (
      this.workRequest.offerType === WorkOfferType.VerbalOffer ||
      this.workRequest.offerType === WorkOfferType.WithoutOffer
    ) {
      return (
        (this.workRequest.phases.length === 1 && this.workRequest.phases[0].status === PhaseSystemStatus.Closed) ||
        (this.workRequest.phases.length === 2 && this.workRequest.phases[1].status === PhaseSystemStatus.Closed)
      )
    }

    return false
  }

  public get workType(): string {
    let translatedType = this.$t(`workFileTracking.tracking.workTypeDescription.${this.workRequest.code}`).toString()
    if (translatedType.indexOf('workFileTracking.tracking.workTypeDescription.') > -1) {
      // unsupported type => generic type
      translatedType = this.$t(`workFileTracking.tracking.workTypeDescription.generic`).toString()
    }
    return translatedType
  }

  public get appointment(): WorkAppointment | null {
    const phases = this.workRequest.phases.filter(
      (p) => p.status !== PhaseSystemStatus.Closed && p.appointment !== null
    )

    return phases.length ? phases[phases.length - 1].appointment : null
  }

  public get executionDate(): string | null {
    const appointment = this.appointment
    if (appointment?.executionDate != null) {
      return `${dateService.displayDateText(appointment.executionDate)} ${this.$t(
        'workFileTracking.tracking.timeSlot.' + appointment.executionTimeSlot
      )}`
    }
    return null
  }

  public get status(): string {
    const phase = this.workRequest.phases.find((p) => p.status === PhaseSystemStatus.Ongoing)
    if (phase) {
      const status = this.$t(
        `workFileTracking.tracking.${this.workRequest.offerType}.name.${phase.status}.${phase.phaseNumber}`
      ).toString()
      return `${status[0].toLowerCase()}${status.substring(1)}`
    }

    return this.workRequestCancelled
      ? (this.$t(`workFileTracking.tracking.${this.workRequest.offerType}.name.cancelled`) as string)
      : (this.$t(`workFileTracking.tracking.${this.workRequest.offerType}.name.closed.text`) as string)
  }

  public get price(): string {
    if (this.workRequest.offerType === WorkOfferType.VerbalOffer) {
      return `${this.workRequest.calculatedPrice}${this.$t('workFileTracking.tracking.euroVatInvoiceAfterWork')}`
    }

    if (this.workRequest.offerType === WorkOfferType.WrittenOffer) {
      return `${this.workRequest.calculatedPrice}${this.$t('workFileTracking.tracking.euroVat')}`
    }

    return this.$t('workFileTracking.tracking.free').toString()
  }

  public get outOfClick(): boolean {
    const hours = timeService.getBelgianTime().hours
    return hours < 7 || hours >= 23
  }

  public get canModifyCancelAppointmentBusinessCondition(): boolean {
    const appointment = this.appointment

    if (!appointment?.executionDate) {
      return false
    }

    if (appointment?.hasAssignedEmployee || dateService.diffDate(new Date(), appointment.executionDate) < 14) {
      return false
    }

    if (this.workRequest.type === WorkRequestType.Unknown) {
      return false
    }

    if (this.workRequest.powerLevel === PowerLevel.Unknown) {
      return false
    }

    return true
  }

  public get canModifyCancelAppointment(): boolean {
    return this.outOfClick || this.canModifyCancelAppointmentBusinessCondition
  }

  public get isSmartMeterWorkFileWithOwnerTenantUsufructuary(): boolean {
    return (
      this.workFile.topic === WorkRequestTopic.SmartMeter &&
      this.workFile.clientType === ClientType.OwnerTenantUsufructuary
    )
  }
  //#endregion

  //#region [Method]
  public modifyDate() {
    this.$emit('modifyDate')
  }

  public cancelWork() {
    this.$emit('cancelWork')
  }
  //#endregion
}
</script>
<style scoped>
.lib__feedback__content {
  font-weight: normal !important;
}
</style>